module.exports = {"breakPointXs":"767px","breakPointSm":"1023px","breakPointMd":"1199px"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/sass-variable-loader/dist!./src/assets/styles/scssVariables/breakpoints.scss
// module id = 415
// module chunks = 0